"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

// the value of visibleMemberCount should optimally be divisible by 10
var GroupMembers = function GroupMembers(_ref) {
  var members = _ref.members,
      memberCount = _ref.memberCount,
      _ref$visibleMemberCou = _ref.visibleMemberCount,
      visibleMemberCount = _ref$visibleMemberCou === void 0 ? 30 : _ref$visibleMemberCou;
  var visibleMembers = members.slice(0, visibleMemberCount);
  return (0, _preact.h)("div", {
    className: "widget group-content-container-members"
  }, (0, _preact.h)("h3", {
    className: "widget-title"
  }, (0, _preact.h)(_phrase.default, {
    p: "Members"
  })), (0, _preact.h)("div", {
    className: "group-content-container-members_member-list groups-v1-styles"
  }, visibleMembers.map(function (member, index) {
    return (0, _preact.h)("div", {
      key: index,
      className: "group-content-container-members_member-list_list-item-outer groups-v1-styles"
    }, (0, _preact.h)("div", {
      className: "group-content-container-members_member-list_list-item-inner groups-v1-styles"
    }, (0, _preact.h)(_UserAvatar.default, {
      key: member.id,
      user: member,
      extraClass: "thread-list-avatar avatar--fill-parent",
      showRank: true,
      width: 40,
      height: 40
    })));
  })), memberCount > visibleMemberCount && (0, _preact.h)("div", {
    className: "group-content-container-members_additional-member-count"
  }, "+ ", memberCount - visibleMemberCount));
};

var _default = GroupMembers;
exports.default = _default;